var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyAlt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_44)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 23.5,
    r: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 175.5,
    r: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.825 2.34479e-05C91.1838 0.00941481 83.5569 0.661716 76.025 1.95002C55.825 5.52502 52.175 12.975 52.175 26.75V45H100V51H34.25C20.4 51 8.25005 59.325 4.45005 75.175C4.92334e-05 93.35 4.92334e-05 104.7 4.45005 123.675C7.85005 137.8 15.95 147.875 29.8 147.875H46.225V126.075C46.3983 118.24 49.5982 110.776 55.1538 105.249C60.7094 99.721 68.1892 96.5588 76.025 96.425H123.675C126.832 96.3989 129.953 95.7507 132.86 94.5175C135.766 93.2844 138.401 91.4904 140.614 89.2383C142.827 86.9861 144.574 84.3198 145.755 81.392C146.937 78.4642 147.53 75.3322 147.5 72.175V26.75C147.5 13.825 136.6 4.10002 123.65 1.95002C115.444 0.608824 107.14 -0.043451 98.825 2.34479e-05ZM73.025 14.625C74.8299 14.5953 76.6028 15.103 78.1183 16.0835C79.6338 17.0641 80.8235 18.4732 81.536 20.1317C82.2486 21.7902 82.4517 23.6231 82.1198 25.3974C81.7878 27.1717 80.9356 28.8072 79.6717 30.0959C78.4077 31.3845 76.789 32.2682 75.0215 32.6345C73.254 33.0008 71.4174 32.8331 69.7455 32.1528C68.0735 31.4725 66.6416 30.3104 65.6319 28.8141C64.6222 27.3178 64.0802 25.5551 64.075 23.75C64.055 21.3541 64.986 19.048 66.6637 17.3374C68.3415 15.6268 70.6292 14.6514 73.025 14.625Z",
    fill: "url(#paint0_linear_9_44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.475 51V72.175C153.406 80.1062 150.261 87.701 144.702 93.3581C139.143 99.0153 131.604 102.293 123.675 102.5H76.0251C69.6713 102.63 63.6204 105.24 59.1642 109.771C54.7081 114.301 52.1998 120.395 52.175 126.75V172.125C52.175 185.05 63.4 192.65 76.0251 196.35C91.5365 201.211 108.164 201.211 123.675 196.35C135.7 192.875 147.5 185.875 147.5 172.125V153.925H100V147.875H171.4C185.25 147.875 190.425 138.2 195.25 123.675C200.25 108.675 200.025 94.35 195.25 75.175C191.825 61.375 185.25 51 171.4 51H153.475ZM126.675 166C128.482 165.97 130.257 166.479 131.774 167.462C133.29 168.445 134.48 169.857 135.191 171.518C135.902 173.18 136.102 175.015 135.766 176.791C135.43 178.566 134.573 180.202 133.304 181.489C132.035 182.775 130.412 183.655 128.641 184.016C126.87 184.376 125.032 184.202 123.361 183.514C121.69 182.826 120.261 181.656 119.258 180.153C118.254 178.65 117.72 176.882 117.725 175.075C117.718 172.692 118.657 170.404 120.335 168.712C122.012 167.021 124.292 166.063 126.675 166.05V166Z",
    fill: "url(#paint1_linear_9_44)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_44",
    x1: -4.61795,
    y1: 6.87902,
    x2: 105.653,
    y2: 100.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_44",
    x1: 146.022,
    y1: 159.596,
    x2: 106.307,
    y2: 104.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyAlt2);
export default __webpack_public_path__ + "static/media/py-alt2.bc9c95f698d78bc615d753d87f81ac66.svg";
export { ForwardRef as ReactComponent };